import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { ImageModule } from '@nano/common/image';

import { AvatarComponent } from './avatar.component';
import { AvatarTextPipe } from './avatar-text.pipe';

@NgModule({
  imports: [CommonModule, ImageModule, NzPopoverModule],
  declarations: [AvatarComponent, AvatarTextPipe],
  exports: [AvatarComponent]
})
export class AvatarModule {}
